import script from "./ViaggioInterattivoTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./ViaggioInterattivoTimeline.vue?vue&type=script&setup=true&lang=js"

import "./ViaggioInterattivoTimeline.vue?vue&type=style&index=0&id=3903c352&lang=scss"

const __exports__ = script;

export default __exports__